import { base64Validator } from '@lucidlink/dto/validation';
import { z } from '@lucidlink/dto/z';
import { createDrawerCodec } from './createDrawerCodec.helper';
export const GuestDetailsCodec = createDrawerCodec('guestDetails', [
    ['workspaceId', z.string().nonempty()],
    ['filespaceId', z.string().nonempty()],
    [
        'eGuestEmail',
        base64Validator({
            requiredError: 'internal.key.required',
            minLength: { min: 1, error: 'internal.key.minLength' },
            invalidFormatError: 'internal.key.base64',
        }),
    ],
]);
